import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Flower2 } from "lucide-react";
import { site } from "../content";
import { Reveal, SectionHeading } from "./Reveal";

export default function Sensory() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section id="experiencia" ref={ref} data-testid="sensory-section" className="relative overflow-x-clip py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid items-center gap-14 lg:grid-cols-2">
          <Reveal className="order-2 lg:order-1">
            <motion.div style={{ y }} className="relative">
              <div className="spotlight-gold absolute inset-0 scale-125" aria-hidden="true" />
              <img
                src={site.assets.sensory}
                alt="Profissional retirando toalha quente do Barber Steamer"
                loading="lazy"
                data-testid="sensory-image"
                className="relative aspect-[4/5] w-full rounded-2xl border border-white/10 object-cover shadow-[0_32px_80px_rgba(0,0,0,0.6)]"
              />
            </motion.div>
          </Reveal>

          <div className="order-1 lg:order-2">
            <SectionHeading
              chapter="05"
              eyebrow="Experiência sensorial"
              title="Uma experiência que o cliente sente."
              subtitle={site.sensory.text}
              testId="sensory-heading"
            />
            <Reveal delay={0.2}>
              <ul className="mt-10 flex flex-wrap gap-3" data-testid="sensory-words">
                {site.sensory.words.map((word) => (
                  <li
                    key={word}
                    className="rounded-full border border-gold/30 bg-gold/[0.06] px-5 py-2.5 font-display text-xs font-bold uppercase tracking-[0.25em] text-gold"
                  >
                    {word}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1}>
          <div
            id="aromatizacao"
            data-testid="aromatization-block"
            className="mt-24 grid items-center gap-10 rounded-3xl border border-white/10 bg-graphite/60 p-10 backdrop-blur-xl md:grid-cols-[auto_1fr] md:p-14"
          >
            <div className="flex h-16 w-16 items-center justify-center rounded-2xl border border-gold/30 bg-gold/[0.08] text-gold">
              <Flower2 className="h-7 w-7" aria-hidden="true" />
            </div>
            <div>
              <p className="flex items-center gap-4">
                <span className="font-display text-xs font-bold tracking-[0.4em] text-gold">06</span>
                <span className="h-px w-10 bg-gold/50" aria-hidden="true" />
                <span className="font-serif text-lg italic text-bone/60">Aromatização</span>
              </p>
              <h3 className="mt-4 font-display text-2xl font-extrabold uppercase tracking-tight text-bone sm:text-3xl">
                Transforme o atendimento em uma experiência
              </h3>
              <p className="mt-4 max-w-2xl text-base leading-relaxed text-bone/60">
                {site.sensory.aromaText}
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
